import React from "react";
import { useTheme } from "@emotion/react";

const WalletIconSvg = ({ width = "110", height = "110" }) => {
  const theme = useTheme();
  
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 110 110"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1_1)">
        <rect
          x="15"
          y="25"
          width="80"
          height="55"
          rx="8"
          fill={theme.palette.primary.main}
        />
        <rect
          x="15.5"
          y="25.5"
          width="79"
          height="54"
          rx="7.5"
          stroke={theme.palette.primary.dark}
          strokeOpacity="0.2"
        />
      </g>
      
      {/* Wallet flap */}
      <rect
        x="20"
        y="20"
        width="70"
        height="12"
        rx="6"
        fill={theme.palette.primary.dark}
      />
      
      {/* Card slot */}
      <rect
        x="25"
        y="35"
        width="35"
        height="20"
        rx="2"
        fill={theme.palette.background.paper}
        fillOpacity="0.9"
      />
      
      {/* Card lines */}
      <line
        x1="28"
        y1="40"
        x2="55"
        y2="40"
        stroke={theme.palette.primary.main}
        strokeWidth="1"
        strokeOpacity="0.6"
      />
      <line
        x1="28"
        y1="45"
        x2="50"
        y2="45"
        stroke={theme.palette.primary.main}
        strokeWidth="1"
        strokeOpacity="0.6"
      />
      <line
        x1="28"
        y1="50"
        x2="45"
        y2="50"
        stroke={theme.palette.primary.main}
        strokeWidth="1"
        strokeOpacity="0.6"
      />
      
      {/* Money bills */}
      <rect
        x="65"
        y="40"
        width="20"
        height="12"
        rx="1"
        fill={theme.palette.success.main}
        fillOpacity="0.8"
      />
      <rect
        x="67"
        y="45"
        width="16"
        height="8"
        rx="1"
        fill={theme.palette.success.main}
        fillOpacity="0.6"
      />
      <rect
        x="69"
        y="50"
        width="12"
        height="6"
        rx="1"
        fill={theme.palette.success.main}
        fillOpacity="0.4"
      />
      
      {/* Coin */}
      <circle
        cx="42"
        cy="65"
        r="8"
        fill={theme.palette.warning.main}
        fillOpacity="0.8"
      />
      <circle
        cx="42"
        cy="65"
        r="5"
        fill={theme.palette.warning.dark}
        fillOpacity="0.6"
      />
      <text
        x="42"
        y="68"
        textAnchor="middle"
        fontSize="6"
        fill={theme.palette.background.paper}
        fontWeight="bold"
      >
        $
      </text>
      
      {/* Additional coins */}
      <circle
        cx="58"
        cy="62"
        r="6"
        fill={theme.palette.warning.main}
        fillOpacity="0.6"
      />
      <circle
        cx="58"
        cy="62"
        r="4"
        fill={theme.palette.warning.dark}
        fillOpacity="0.4"
      />
      
      <circle
        cx="72"
        cy="68"
        r="5"
        fill={theme.palette.warning.main}
        fillOpacity="0.5"
      />
      <circle
        cx="72"
        cy="68"
        r="3"
        fill={theme.palette.warning.dark}
        fillOpacity="0.3"
      />
      
      <defs>
        <filter
          id="filter0_d_1_1"
          x="11"
          y="21"
          width="88"
          height="63"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1_1"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1_1"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default WalletIconSvg;